import { useEffect, useRef } from "react";
import { StreamerStatus } from "../../interlucent/streamerStatus";
var ACTIVITY_EVENTS = ["mousemove", "mousedown", "keydown", "touchstart", "wheel"];
export default function IdleTimeout(_a) {
    var Status = _a.Status, WarningThreshold = _a.WarningThreshold, ExitThreshold = _a.ExitThreshold, WarningCallback = _a.WarningCallback, ExitCallback = _a.ExitCallback;
    var warningTimer = useRef();
    var exitTimer = useRef();
    useEffect(function () {
        if (Status !== StreamerStatus.Connected)
            return;
        var clearTimers = function () {
            clearTimeout(warningTimer.current);
            clearTimeout(exitTimer.current);
        };
        var scheduleWarning = function () {
            clearTimers();
            warningTimer.current = setTimeout(function () {
                WarningCallback();
                exitTimer.current = setTimeout(ExitCallback, ExitThreshold * 1000);
            }, WarningThreshold * 1000);
        };
        ACTIVITY_EVENTS.forEach(function (evt) { return window.addEventListener(evt, scheduleWarning); });
        scheduleWarning();
        return function () {
            ACTIVITY_EVENTS.forEach(function (evt) { return window.removeEventListener(evt, scheduleWarning); });
            clearTimers();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Status, WarningThreshold, ExitThreshold]);
    return null;
}
